module.exports = __webpack_public_path__ + "img/won.6f945f34.svg";